/**
 * Format large numbers for axis labels
 * Examples: 1000 -> "1k", 6500 -> "6.5k", 10000 -> "10k", 1500000 -> "1.5M"
 * @param {number} value - The number to format
 * @returns {string} - Formatted string
 */
export function formatAxisValue(value) {
  if (value == null) {
    return "0";
  }

  const absValue = Math.abs(value);

  if (absValue >= 1000000) {
    const formatted = (value / 1000000).toFixed(1);
    // Remove .0 suffix
    return formatted.endsWith(".0") ? `${Math.floor(value / 1000000)}M` : `${formatted}M`;
  }

  if (absValue >= 1000) {
    const formatted = (value / 1000).toFixed(1);
    // Remove .0 suffix
    return formatted.endsWith(".0") ? `${Math.floor(value / 1000)}k` : `${formatted}k`;
  }

  return value.toString();
}
